import{Observable as t}from"../Observable.js";function n(n){return!!n&&(n instanceof t||"function"==typeof n.lift&&"function"==typeof n.subscribe)}export{n as isObservable};
